const name = 'orders';

export const GET_ORDERS_LIST_REQUEST = `${name}/GET_ORDERS_LIST_REQUEST`;
export const GET_ORDERS_LIST_SUCCESS = `${name}/GET_ORDERS_LIST_SUCCESS`;
export const GET_ORDERS_LIST_FAILURE = `${name}/GET_ORDERS_LIST_FAILURE`;

export const GET_ORDERS_TABLE_CONFIGURATION_REQUEST = `${name}/GET_ORDERS_TABLE_CONFIGURATION_REQUEST`;
export const GET_ORDERS_TABLE_CONFIGURATION_SUCCESS = `${name}/GET_ORDERS_TABLE_CONFIGURATION_SUCCESS`;
export const GET_ORDERS_TABLE_CONFIGURATION_FAILURE = `${name}/GET_ORDERS_TABLE_CONFIGURATION_FAILURE`;

export const UPDATE_ORDERS_TABLE_ROW_REQUEST = `${name}/UPDATE_ORDERS_TABLE_ROW_REQUEST`;
export const UPDATE_ORDERS_TABLE_ROW_SUCCESS = `${name}/UPDATE_ORDERS_TABLE_ROW_SUCCESS`;
export const UPDATE_ORDERS_TABLE_ROW_FAILURE = `${name}/UPDATE_ORDERS_TABLE_ROW_FAILURE`;

export const GET_ORDERS_DETAILS_REQUEST = `${name}/GET_ORDERS_DETAILS_REQUEST`;
export const GET_ORDERS_DETAILS_SUCCESS = `${name}/GET_ORDERS_DETAILS_SUCCESS`;
export const GET_ORDERS_DETAILS_FAILURE = `${name}/GET_ORDERS_DETAILS_FAILURE`;

export const GET_ALL_CLIENT_ORDERS_REQUEST = `${name}/GET_ALL_CLIENT_ORDERS_REQUEST`;
export const GET_ALL_CLIENT_ORDERS_SUCCESS = `${name}/GET_ALL_CLIENT_ORDERS_SUCCESS`;
export const GET_ALL_CLIENT_ORDERS_FAILURE = `${name}/GET_ALL_CLIENT_ORDERS_FAILURE`;

export const UPDATE_ORDER_DETAILS_REQUEST = `${name}/UPDATE_ORDER_DETAILS_REQUEST`;
export const UPDATE_ORDER_DETAILS_SUCCESS = `${name}/UPDATE_ORDER_DETAILS_SUCCESS`;
export const UPDATE_ORDER_DETAILS_FAILURE = `${name}/UPDATE_ORDER_DETAILS_FAILURE`;

export const DELETE_ORDER_DETAILS_REQUEST = `${name}/DELETE_ORDER_DETAILS_REQUEST`;
export const DELETE_ORDER_DETAILS_SUCCESS = `${name}/DELETE_ORDER_DETAILS_SUCCESS`;
export const DELETE_ORDER_DETAILS_FAILURE = `${name}/DELETE_ORDER_DETAILS_FAILURE`;

export const UPDATE_ORDER_STATUS_REQUEST = `${name}/UPDATE_ORDER_STATUS_REQUEST`;
export const UPDATE_ORDER_STATUS_SUCCESS = `${name}/UPDATE_ORDER_STATUS_SUCCESS`;
export const UPDATE_ORDER_STATUS_FAILURE = `${name}/UPDATE_ORDER_STATUS_FAILURE`;

export const MERGE_ORDER_PRODUCTS_REQUEST = `${name}/MERGE_ORDER_PRODUCTS_REQUEST`;
export const MERGE_ORDER_PRODUCTS_SUCCESS = `${name}/MERGE_ORDER_PRODUCTS_SUCCESS`;
export const MERGE_ORDER_PRODUCTS_FAILURE = `${name}/MERGE_ORDER_PRODUCTS_FAILURE`;

export const EXPORT_ORDERS_REQUEST = `${name}/EXPORT_ORDERS_REQUEST`;
export const EXPORT_ORDERS_SUCCESS = `${name}/EXPORT_ORDERS_SUCCESS`;
export const EXPORT_ORDERS_FAILURE = `${name}/EXPORT_ORDERS_FAILURE`;

export const CALL_CLIENT_REQUEST = `${name}/CALL_CLIENT_REQUEST`;
export const CALL_CLIENT_SUCCESS = `${name}/CALL_CLIENT_SUCCESS`;
export const CALL_CLIENT_FAILURE = `${name}/CALL_CLIENT_FAILURE`;

export const GET_CALL_URL_REQUEST = `${name}/GET_CALL_URL_REQUEST`;
export const GET_CALL_URL_SUCCESS = `${name}/GET_CALL_URL_SUCCESS`;
export const GET_CALL_URL_FAILURE = `${name}/GET_CALL_URL_FAILURE`;

export const UPDATE_ORDER_COMMENT_REQUEST = `${name}/UPDATE_ORDER_COMMENT_REQUEST`;
export const UPDATE_ORDER_COMMENT_SUCCESS = `${name}/UPDATE_ORDER_COMMENT_SUCCESS`;
export const UPDATE_ORDER_COMMENT_FAILURE = `${name}/UPDATE_ORDER_COMMENT_FAILURE`;

export const ATTACH_ORDER_FILE_REQUEST = `${name}/ATTACH_ORDER_FILE_REQUEST`;
export const ATTACH_ORDER_FILE_SUCCESS = `${name}/ATTACH_ORDER_FILE_SUCCESS`;
export const ATTACH_ORDER_FILE_FAILURE = `${name}/ATTACH_ORDER_FILE_FAILURE`;

export const GET_ALL_ORDER_BANK_TRANSACTIONS_REQUEST = `${name}/GET_ALL_ORDER_BANK_TRANSACTIONS_REQUEST`;
export const GET_ALL_ORDER_BANK_TRANSACTIONS_SUCCESS = `${name}/GET_ALL_ORDER_BANK_TRANSACTIONS_SUCCESS`;
export const GET_ALL_ORDER_BANK_TRANSACTIONS_FAILURE = `${name}/GET_ALL_ORDER_BANK_TRANSACTIONS_FAILURE`;

export const CREATE_NEW_ORDER_COST_REQUEST = `${name}/CREATE_NEW_ORDER_COST_REQUEST`;
export const CREATE_NEW_ORDER_COST_SUCCESS = `${name}/CREATE_NEW_ORDER_COST_SUCCESS`;
export const CREATE_NEW_ORDER_COST_FAILURE = `${name}/CREATE_NEW_ORDER_COST_FAILURE`;

export const GET_ORDER_SHORTLINK_REQUEST = `${name}/GET_ORDER_SHORTLINK_REQUEST`;
export const GET_ORDER_SHORTLINK_SUCCESS = `${name}/GET_ORDER_SHORTLINK_SUCCESS`;
export const GET_ORDER_SHORTLINK_FAILURE = `${name}/GET_ORDER_SHORTLINK_FAILURE`;

export const GET_ORDER_DEFAULT_DATA_REQUEST = `${name}/GET_ORDER_DEFAULT_DATA_REQUEST`;
export const GET_ORDER_DEFAULT_DATA_SUCCESS = `${name}/GET_ORDER_DEFAULT_DATA_SUCCESS`;
export const GET_ORDER_DEFAULT_DATA_FAILURE = `${name}/GET_ORDER_DEFAULT_DATA_FAILURE`;

export const GET_PRICE_GROUP_DATA_REQUEST = `${name}/GET_PRICE_GROUP_DATA_REQUEST`;
export const GET_PRICE_GROUP_DATA_SUCCESS = `${name}/GET_PRICE_GROUP_DATA_SUCCESS`;
export const GET_PRICE_GROUP_DATA_FAILURE = `${name}/GET_PRICE_GROUP_DATA_FAILURE`;

export const GET_CURRENCY_DATA_REQUEST = `${name}/GET_CURRENCY_DATA_REQUEST`;
export const GET_CURRENCY_DATA_SUCCESS = `${name}/GET_CURRENCY_DATA_SUCCESS`;
export const GET_CURRENCY_DATA_FAILURE = `${name}/GET_CURRENCY_DATA_FAILURE`;

export const SEND_ORDER_ACTION_REQUEST = `${name}/SEND_ORDER_ACTION_REQUEST`;
export const SEND_ORDER_ACTION_SUCCESS = `${name}/SEND_ORDER_ACTION_SUCCESS`;
export const SEND_ORDER_ACTION_FAILURE = `${name}/SEND_ORDER_ACTION_FAILURE`;

export default name;
